import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const SCROLLED_SECRETS_ACTIVITY_FRAGMENT = gql `
  fragment ScrolledSecretsActivityFragment on ScrolledSecretsActivity {
    rounds {
      activityImage {
        image {
          ...AssetFragment
        }
      }
      answers {
        label
        answer
      }
      draggables
      paragraphs
      roundTitle
    }
  }
  ${ASSET_FRAGMENT}
`;
export default SCROLLED_SECRETS_ACTIVITY_FRAGMENT;
